import React, { useState } from 'react';
import { Modal, Tooltip, Input } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Row, Widget, Col } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import { Visibility } from '@app/components/Visibility';
import { excluirDocumento } from '@app/api/ContabilidadeGeral';

interface Props {
    justificativa: string;
}

const ModalJustificativaExclusao = ({ justificativa }: Props) => {
    const [exibirModal, setExibirModal] = useState(false);


    return (
        <>
            <Tooltip title="Visualizar Justificativa da Exclusão">
                <Button
                    onClick={() => setExibirModal(true)}
                    icon="ui-information"
                    name='btnJustificativaExcusao'
                />
            </Tooltip>
            <Visibility visible={exibirModal} >
                <Modal
                    title="Justificativa da Exclusão"
                    width='780px'
                    visible={exibirModal}
                    onCancel={() => {
                        setExibirModal(false);
                    }}
                    footer={[
                        <Button
                            type='link'
                            onClick={() => {
                                setExibirModal(false);
                            }}>
                            Fechar
                        </Button>
                    ]}>
                    <Input.TextArea
                        name="justificativa"
                        value={justificativa}
                        rows={4}
                        maxLength={2000}
                        disabled
                    />
                </Modal>
            </Visibility>
        </>
    );
};

export default ModalJustificativaExclusao;